export const PASSWORD_REGEX = /(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9@!;#$%&)(-^:,.~*<>?]{8,20}$/;

export const SPACE_REGEX = /^\s+$/;

export const URL_SPACE_REGEX = /^\S+$/;

export const HTML_REGEX = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
